<div mat-dialog-title class="dialog-header">
  <app-x-icon-button title="Fermer" (click)="close()"></app-x-icon-button>
  <div>
    <h3>Attestation et numéro de sécurité sociale</h3>
    @if (contract) {
      <h4>
        {{ contract.employee.title }} {{ contract.employee.firstname }}
        {{ contract.employee.lastname }}
      </h4>
    }
  </div>
</div>
<mat-dialog-content>
  @if (contract) {
    <app-social-security-document-and-number
      #content
      [contract]="contract"
    ></app-social-security-document-and-number>
  } @else {
    <div class="loading-container">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <app-save-button
    (click)="onOk()"
    [isEditMode]="false"
    [enabled]="isValid"
    matTooltip=""
  ></app-save-button>
</mat-dialog-actions>
